export interface SortingOption {
  code: string;
  showSortingSelector: boolean;
  sortingFields: Array<SortingField>;
}

export interface SortingField {
  field: string;
  key: string;
  isDefaultField: boolean;
}

export const SORTING_OPTIONS: SortingOption[] =
  [
    {
      code: "new",
      showSortingSelector: true,
      sortingFields: [
        {
          field: "-relevancy",
          key: "relevancy",
          isDefaultField: false
        },
        {
          field: "-date",
          key: "dateSorting",
          isDefaultField: true
        }
      ]
    },
    {
      code: "dpl",
      showSortingSelector: false,
      sortingFields: [
        {
          field: "+shorttitle",
          key: "shorttitle",
          isDefaultField: true
        }
      ]
    },
    {
      code: "cnw",
      showSortingSelector: false,
      sortingFields: [
        {
          field: "+nigenso1",
          key: "nigenso1",
          isDefaultField: true
        }
      ]
    }
  ]
